'use strict';

angular.module('cca.components.ccaChangeDayTimeDialog',
    [
        'shared.components.sbModalHeader',
        'shared.controllers.confirmationPopup',
        'shared.services.simpleAlertService',
    ])
    .component('ccaChangeDayTimeDialog',
        {
            bindings: {
                resolve: '<',
                modalInstance: '<',
            },
            templateUrl: '/Scripts/app/cca/components/cca-change-day-time-dialog.template.html',
            controller: class CcaChangeDayTimeDialogCtrl
            {
                $timeout: any;
                $translate: any;
                signUpRepository: any;
                simpleAlertService: any;
                isSubmitted: boolean = false;
                items: any;
                changes: any;
                signUpGroups: any;
                status: any;

                modalInstance: any;

                static $inject = ['$timeout', '$translate', 'signUpRepository', 'simpleAlertService'];

                constructor($timeout, $translate, signUpRepository, simpleAlertService)
                {
                    this.$timeout = $timeout;
                    this.$translate = $translate;
                    this.simpleAlertService = simpleAlertService;
                    this.signUpRepository = signUpRepository;

                    this.items = signUpRepository.getDaysOfWeek(true);
                    this.items.unshift(
                        {
                            id: -1,
                            name: 'SB_No_Change'
                        }
                    );
                }

                $onInit()
                {
                    this.changes = [];
                };

                $onChanges(changes)
                {
                    if (changes.modalInstance)
                    {
                        this.modalInstance = changes.modalInstance.currentValue;
                    }

                    if (changes.resolve && changes.resolve.currentValue)
                    {
                        this.signUpGroups = []
                        let signUpGroup = changes.resolve.currentValue.signUpGroup;

                        signUpGroup.newCcaStartHour = signUpGroup.ccaStartHour;
                        signUpGroup.newCcaStartMin = signUpGroup.ccaStartMin;
                        signUpGroup.newCcaEndHour = signUpGroup.ccaEndHour;
                        signUpGroup.newCcaEndMin = signUpGroup.ccaEndMin;

                        signUpGroup.ccaStartHourMin = { h: signUpGroup.newCcaStartHour, m: signUpGroup.newCcaStartMin };
                        signUpGroup.ccaEndHourMin = { h: signUpGroup.newCcaEndHour, m: signUpGroup.newCcaEndMin };
                        signUpGroup.newCcaStartHourMin = { h: signUpGroup.newCcaStartHour, m: signUpGroup.newCcaStartMin };
                        signUpGroup.newCcaEndHourMin = { h: signUpGroup.newCcaEndHour, m: signUpGroup.newCcaEndMin };

                        let currentDayOfWeekItem = this.items.filter((item) =>
                        {
                            return item.id == signUpGroup.dayofWeek;
                        });

                        signUpGroup.dayOfWeekName = currentDayOfWeekItem[0].name;
                        signUpGroup.newDayofWeek = -1; // No Change

                        signUpGroup.formattedTimes = ("00" + signUpGroup.ccaStartHour).slice(-2) + ':' + ("00" + signUpGroup.ccaStartMin).slice(-2) + '-' + ("00" + signUpGroup.ccaEndHour).slice(-2) + ':' + ("00" + signUpGroup.ccaEndMin).slice(-2);

                        this.signUpGroups.push(signUpGroup);

                        signUpGroup.linkedGroups.filter((linkedGroup) =>
                        {
                            linkedGroup.title = signUpGroup.title;

                            linkedGroup.newCcaStartHour = linkedGroup.ccaStartHour;
                            linkedGroup.newCcaStartMin = linkedGroup.ccaStartMin;
                            linkedGroup.newCcaEndHour = linkedGroup.ccaEndHour;
                            linkedGroup.newCcaEndMin = linkedGroup.ccaEndMin;

                            linkedGroup.ccaStartHourMin = { h: linkedGroup.newCcaStartHour, m: linkedGroup.newCcaStartMin };
                            linkedGroup.ccaEndHourMin = { h: linkedGroup.newCcaEndHour, m: linkedGroup.newCcaEndMin };
                            linkedGroup.newCcaStartHourMin = { h: linkedGroup.newCcaStartHour, m: linkedGroup.newCcaStartMin };
                            linkedGroup.newCcaEndHourMin = { h: linkedGroup.newCcaEndHour, m: linkedGroup.newCcaEndMin };

                            let currentDayOfWeekItem = this.items.filter((item) =>
                            {
                                return item.id == linkedGroup.dayofWeek;
                            });

                            linkedGroup.dayOfWeekName = currentDayOfWeekItem[0].name;
                            linkedGroup.newDayofWeek = -1; // No Change

                            linkedGroup.formattedTimes = ("00" + linkedGroup.ccaStartHour).slice(-2) + ':' + ("00" + linkedGroup.ccaStartMin).slice(-2) + '-' + ("00" + linkedGroup.ccaEndHour).slice(-2) + ':' + ("00" + linkedGroup.ccaEndMin).slice(-2);

                            this.signUpGroups.push(linkedGroup);
                        });

                        this.status =
                        {
                            isItemOpen: new Array(this.signUpGroups.length),
                            isFirstDisabled: false
                        };
                        this.status.isItemOpen[0] = true;
                    }
                };

                dayOrTimeChanged()
                {
                    // Must return undefined: sb-time-picker invokes the return value of onChange().
                    this.$timeout(() =>
                    {
                        this.rebuildChanges();
                    }, 200);
                }

                // The blank Day option sets null; treat null/undefined like -1 ("no day change").
                effectiveNewDayOfWeek(signUpGroup): number
                {
                    return signUpGroup.newDayofWeek == null ? -1 : signUpGroup.newDayofWeek;
                }

                isSectionChanged(signUpGroup): boolean
                {
                    let newDayOfWeek = this.effectiveNewDayOfWeek(signUpGroup);

                    return !((newDayOfWeek == -1 || newDayOfWeek == signUpGroup.dayofWeek) &&
                        signUpGroup.ccaStartHourMin.h == signUpGroup.newCcaStartHourMin.h &&
                        signUpGroup.ccaStartHourMin.m == signUpGroup.newCcaStartHourMin.m &&
                        signUpGroup.ccaEndHourMin.h == signUpGroup.newCcaEndHourMin.h &&
                        signUpGroup.ccaEndHourMin.m == signUpGroup.newCcaEndHourMin.m);
                }

                formatTimes(startHourMin, endHourMin): string
                {
                    return ("00" + startHourMin.h).slice(-2) + ':' + ("00" + startHourMin.m).slice(-2) + '-' + ("00" + endHourMin.h).slice(-2) + ':' + ("00" + endHourMin.m).slice(-2);
                }

                // Derives the change list from the sections' current values, so it always matches the controls.
                rebuildChanges()
                {
                    let changes = [];

                    (this.signUpGroups || []).forEach((signUpGroup) =>
                    {
                        if (!this.isSectionChanged(signUpGroup))
                        {
                            return;
                        }

                        let oldDayOfWeekItem = this.items.filter((item) =>
                        {
                            return item.id == signUpGroup.dayofWeek;
                        });

                        let newDayOfWeek = this.effectiveNewDayOfWeek(signUpGroup);

                        let newDayOfWeekItem = this.items.filter((item) =>
                        {
                            return item.id == newDayOfWeek;
                        });

                        let oldStartHourMin = { h: signUpGroup.ccaStartHourMin.h, m: signUpGroup.ccaStartHourMin.m };
                        let oldEndHourMin = { h: signUpGroup.ccaEndHourMin.h, m: signUpGroup.ccaEndHourMin.m };
                        let newStartHourMin = { h: signUpGroup.newCcaStartHourMin.h, m: signUpGroup.newCcaStartHourMin.m };
                        let newEndHourMin = { h: signUpGroup.newCcaEndHourMin.h, m: signUpGroup.newCcaEndHourMin.m };

                        changes.push(
                            {
                                id: signUpGroup.id,
                                oldDayOfWeek: signUpGroup.dayofWeek,
                                oldDayOfWeekName: this.$translate.instant(oldDayOfWeekItem[0].name),
                                newDayofWeek: newDayOfWeek,
                                newDayOfWeekName: newDayOfWeek == -1
                                    ? this.$translate.instant(oldDayOfWeekItem[0].name)
                                    : this.$translate.instant(newDayOfWeekItem[0].name),
                                oldStartHourMin: oldStartHourMin,
                                newStartHourMin: newStartHourMin,
                                oldEndHourMin: oldEndHourMin,
                                newEndHourMin: newEndHourMin,
                                oldFormattedTimes: this.formatTimes(oldStartHourMin, oldEndHourMin),
                                newFormattedTimes: this.formatTimes(newStartHourMin, newEndHourMin)
                            });
                    });

                    this.changes = changes;
                }

                closeModal(responseDto)
                {
                    this.modalInstance.close(responseDto);
                };

                resetSubmitButtons()
                {
                    this.$timeout(() =>
                    {
                        this.isSubmitted = false;
                    }, 200);
                }

                alertAndResetOkButton(message)
                {
                    this.simpleAlertService.errorAlert(message);
                    this.resetSubmitButtons();
                };

                save()
                {
                    this.rebuildChanges();

                    if (this.changes.length == 0)
                    {
                        this.resetSubmitButtons();
                        return;
                    }

                    this.signUpRepository.updateDayAndTimesForGroups(this.changes)
                        .then((updatesSuccessful) =>
                        {
                            if (updatesSuccessful)
                            {
                                var response =
                                {
                                    status: 'updated'
                                };

                                this.closeModal(response);
                            }
                            else
                            {
                                this.alertAndResetOkButton({
                                    message: 'SB_An_Error_Occurred_Performing_Cca_Group_Updates'
                                });
                            }
                        })
                        .catch((err) =>
                        {
                            this.simpleAlertService.errorAlert();
                        });
                };

                cancel()
                {
                    let response =
                    {
                        status: 'cancelled'
                    };

                    this.closeModal(response);
                }
            }
        });
